<template>
  <div class="separate-care">
    <b-overlay :show="loadingVerify" opacity="0.99">
      <div class="row">
        <div class="col-md-12 pt-0">
          <Care :group_prescription_care="group_prescription_care" />
        </div>
        <div class="col-md-12">
          <div class="notdiv-realized">
            <b-form-checkbox
              @input="handleChabgeChecked"
              id="checked"
              v-model="checked"
              name="checked"
              class="mb-1"
            >
              MARCAR COMO NÃO REALIZADO?
            </b-form-checkbox>
            <h6 class="color-deleted mb-0 worksansr" v-if="checked">
              MOTIVO DA NÃO REALIZAÇÃO:
            </h6>
            <ChromeSpeechToTextTextarea
              rows="4"
              max-rows="10"
              v-model="note"
              v-if="checked"
            />
          </div>
        </div>
        <div class="col-md-12 pt-0 pb-0" v-if="!checked">
          <div class="row">
            <div
              v-show="
                group_prescription_care.prescription_care.care_name == 'DOR'
              "
              class="col-md-12 pt-0 pb-0"
            >
              <h6 class="mb-1 color-blue text-for">DOR - ESCALA EVA:</h6>
              <div class="row">
                <div
                  class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 border-right text-center"
                >
                  <img width="25" src="../../../../assets/emoji/1.png" />
                  <h6 class="mb-0 text-for">SEM DOR</h6>
                  <span class="worksansr">0</span>
                </div>
                <div
                  class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 border-right text-center"
                >
                  <img width="25" src="../../../../assets/emoji/1.png" />
                  <h6 class="mb-0 text-for">LEVE</h6>
                  <span class="worksansr">1-3</span>
                </div>
                <div
                  class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 border-right text-center"
                >
                  <img width="25" src="../../../../assets/emoji/3.png" />
                  <h6 class="mb-0 text-for">MODERADA</h6>
                  <span class="worksansr">4-7</span>
                </div>
                <div
                  class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6 text-center"
                >
                  <img width="25" src="../../../../assets/emoji/4.png" />
                  <h6 class="mb-0 text-for">INTENSA</h6>
                  <span class="worksansr">8-10</span>
                </div>
              </div>
            </div>
            <div class="col-md-12 pt-0 pb-0">
              <div class="input-group">
                <input
                  v-if="show_description"
                  type="text"
                  class="form-control"
                  v-model="description"
                  placeholder="RESPOSTA"
                />
                <select
                  v-if="show_diuresis"
                  v-model="description"
                  class="form-control"
                >
                  <option value>SELECIONE...</option>
                  <option
                    :key="key"
                    :value="item"
                    v-for="(item, key) in types_diuresis"
                  >
                    {{ item }}
                  </option>
                </select>
                <select
                  v-if="show_evacuation"
                  v-model="description"
                  class="form-control"
                >
                  <option value>SELECIONE...</option>
                  <option
                    :key="key"
                    :value="item"
                    v-for="(item, key) in types_evacuation"
                  >
                    {{ item }}
                  </option>
                </select>
                <div
                  v-if="show_blood_pressure"
                  class="input-group-pprend d-flex align-items-center pl-2 pr-2"
                >
                  POR
                </div>

                <input
                  type="text"
                  v-if="show_blood_pressure"
                  class="form-control"
                  placeholder="RESPOSTA"
                  v-model="final_description"
                />

                <div v-if="show_icon" class="input-group-pprend">
                  <v-btn disabled><i :class="icon" /></v-btn>
                </div>
              </div>
            </div>
            <div
              class="col-md-12 separate-care-care-field-required"
              v-if="
                group_prescription_care.prescription_care.care_field_required ==
                1
              "
            >
              <p>Resposta obrigatória</p>
            </div>
          </div>
        </div>
        <div
          class="col-md-12"
          v-if="
            permission('read', 'change_of_position_with_photo') &&
            !checked &&
            group_prescription_care.prescription_care.care_category ==
              'Mudança de Decúbito e Prevenção'
          "
        >
          <Photo @photo-taken="handlePhoto" />
        </div>
        <div class="col-md-12 pt-0 pb-0">
          <p
            v-for="(error, index) in errors"
            :key="index"
            class="errorMessages mb-2"
          >
            {{ error.message || error }}
          </p>
        </div>
        <div class="col-md-12 text-right">
          <v-btn
            :disabled="loading"
            @click="handleToSeparate"
            :class="[
              'btn-modern',
              !checked && 'btn-modern-save',
              checked && 'btn-notcertified',
            ]"
          >
            <i class="fas fa-check mr-2 text-twenty"></i>
            <span>
              {{
                loading
                  ? "CARREGANDO"
                  : "FINALIZAR MANUAL COM ASSINATURA ELETRÔNICA"
              }}
            </span>
          </v-btn>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ChromeSpeechToTextTextarea from "../../../Components/ChromeSpeechToTextTextarea";

import Photo from "./Photo";

import routes from "../../../../routes";

import api from "../../../../services/api";

import toast from "../../../../lib/ToastNotification";

import Care from "../Care";

import { userData } from "../../../../lib/functions";

import { formatDateOnlyNumbers, isNumeric } from "../../../../lib/format";

import permission from "../../../../lib/permission";

export default {
  name: "Separate",
  components: {
    Care,
    ChromeSpeechToTextTextarea,
    Photo,
  },
  props: {
    group_prescription_care: Object,
    date: String,
  },
  data() {
    return {
      photo: null,

      resident_id: "",
      rest_home_id: "",
      note: "",
      description: "",
      initial_description: "",
      final_description: "",
      checked: false,
      loading: false,
      loadingVerify: false,
      errors: [],

      show_description: true,
      show_capillary_glycemia: false,
      show_blood_pressure: false,
      show_icon: false,
      show_diuresis: false,
      show_evacuation: false,

      types_diuresis: [
        "AUSÊNCIA DE DIURESE",
        "DIURESE PRESENTE",
        "POUCA DIURESE",
      ],
      types_evacuation: [
        "AUSENTE",
        "BEM MOLDADAS",
        "EM CÍBALOS",
        "LÍQUIDA",
        "PASTOSA",
      ],
    };
  },
  created() {
    this.retrieve();

    this.handleCareType();
  },

  methods: {
    permission,

    formatDateOnlyNumbers,

    handleChabgeChecked() {},

    handleCareType() {
      let {
        group_prescription_care: {
          prescription_care: { care_name, care_field_required },
        },
      } = this;

      this.show_blood_pressure = false;
      this.show_capillary_glycemia = false;
      this.show_diuresis = false;
      this.show_evacuation = false;
      this.show_description = false;

      let types = [
        "TEMPERATURA CORPORAL",
        "PULSO (FREQUÊNCIA CARDÍACA)",
        "PRESSÃO ARTERIAL",
        "FREQUÊNCIA RESPIRATÓRIA",
        "DOR",
        "GLICEMIA CAPILAR",
        "DIURESE",
        "EVACUAÇÃO",
        "SATURAÇÃO DE OXIGÊNIO",
        "PESO",
        "ALTURA",
      ];

      if (types.includes(care_name)) {
        if (care_name == "TEMPERATURA CORPORAL") {
          this.show_description = true;
        }

        if (care_name == "PULSO (FREQUÊNCIA CARDÍACA)") {
          this.show_description = true;
        }

        if (care_name == "PRESSÃO ARTERIAL") {
          this.show_description = true;
          this.show_blood_pressure = true;
        }

        if (care_name == "FREQUÊNCIA RESPIRATÓRIA") {
          this.show_description = true;
        }

        if (care_name == "DOR") {
          this.show_description = true;
        }

        if (care_name == "GLICEMIA CAPILAR") {
          this.show_description = true;
        }
        this.show_capillary_glycemia = true;

        if (care_name == "DIURESE") {
          this.show_diuresis = true;
        }

        if (care_name == "EVACUAÇÃO") {
          this.show_evacuation = true;
        }

        if (care_name == "SATURAÇÃO DE OXIGÊNIO") {
          this.show_description = true;
        }

        if (care_name == "PESO") {
          this.show_description = true;
        }

        if (care_name == "ALTURA") {
          this.show_description = true;
        }
      } else {
        if (care_field_required == 1) {
          this.show_description = true;
        }
      }
    },

    handlePhoto(photoData) {
      this.photo = photoData;
    },

    handleToSeparate() {
      let {
        checked,
        note,
        description,
        final_description,
        group_prescription_care: {
          prescription_care: {
            care_name,
            care_field_type,
            care_field_required,
            care_category,
          },
        },
        photo,
      } = this;

      if (permission("read", "change_of_position_with_photo")) {
        if (!checked) {
          if (care_category == "Mudança de Decúbito e Prevenção") {
            if (!photo) {
              this.errors = ["Tire a foto"];
              return;
            }
          }
        }
      }

      if (checked) {
        if (!note || !String(note).trim()) {
          this.errors = ["Informe o motivo"];
          return;
        }
      } else {
        let types = [
          "TEMPERATURA CORPORAL",
          "PULSO (FREQUÊNCIA CARDÍACA)",
          "PRESSÃO ARTERIAL",
          "FREQUÊNCIA RESPIRATÓRIA",
          "DOR",
          "GLICEMIA CAPILAR",
          "DIURESE",
          "EVACUAÇÃO",
          "SATURAÇÃO DE OXIGÊNIO",
          "PESO",
          "ALTURA",
        ];

        if (types.includes(care_name)) {
          if (care_field_required == 1) {
            if (!description) {
              this.errors = ["Informe a resposta"];
              return;
            }

            if (care_name == "PRESSÃO ARTERIAL") {
              if (!final_description) {
                this.errors = ["Informe todos os campos"];
                return;
              }
            }

            if (care_field_type == "DESCRIPTION_INITIAL_FINAL") {
              if (!final_description) {
                this.errors = ["Informe todos os campos"];
                return;
              }
            }

            if (care_name == "DOR") {
              if (!isNumeric(description)) {
                this.errors = ["Informe apenas números"];
                return;
              }

              if (parseInt(description) > 10) {
                this.errors = ["Informe número entre [0, 10]"];
                return;
              }

              if (!description) {
                this.description = "0";
              }
            }

            if (care_name == "TEMPERATURA CORPORAL") {
              let validate_description = String(description)
                .replace(",", "")
                .replace(".", "");

              if (!isNumeric(validate_description)) {
                this.errors = ["Informe apenas números"];
                return;
              }

              description = String(description).replace(",", ".");
            }

            if (care_name == "PESO") {
              let validate_description = String(description)
                .replace(",", "")
                .replace(".", "");

              if (!isNumeric(validate_description)) {
                this.errors = ["Informe apenas números"];
                return;
              }

              description = String(description).replace(",", ".");
            }

            if (care_name == "ALTURA") {
              let validate_description = String(description)
                .replace(",", "")
                .replace(".", "");

              if (!isNumeric(validate_description)) {
                this.errors = ["Informe apenas números"];
                return;
              }

              description = String(description).replace(",", ".");
            }

            if (
              care_name != "DIURESE" &&
              care_name != "EVACUAÇÃO" &&
              care_name != "TEMPERATURA CORPORAL" &&
              care_name != "PESO" &&
              care_name != "ALTURA"
            ) {
              if (!isNumeric(description)) {
                this.errors = ["Informe apenas números"];
                return;
              }
              if (care_name == "PRESSÃO ARTERIAL") {
                if (!isNumeric(final_description)) {
                  this.errors = ["Informe apenas números"];
                  return;
                }
                if (parseInt(description) < 29) {
                  this.errors = ["Informe valor acima de 29x39"];
                  return;
                }
                if (parseInt(final_description) < 39) {
                  this.errors = ["Informe valor acima de 29x39"];
                  return;
                }
              }
            }

            if (care_name == "PRESSÃO ARTERIAL") {
              this.initial_description = description;
            }

            if (care_field_type == "DESCRIPTION_NUMBER") {
              if (!isNumeric(description)) {
                this.errors = ["Informe apenas números"];
                return;
              }
            }
          }
        }

        if (care_field_required == 1) {
          if (!description) {
            this.errors = ["Informe a resposta"];
            return;
          }

          if (care_field_type == "DESCRIPTION_INITIAL_FINAL") {
            if (!final_description) {
              this.errors = ["Informe todos os campos"];
              return;
            }
          }
        }
      }

      this.errors = [];

      this.separate();
    },

    async retrieve() {
      this.errors = [];

      let { rest_home_id } = userData();

      this.rest_home_id = rest_home_id;

      const { id } = routes.history.current.params;

      this.resident_id = id;
    },

    async separate() {
      try {
        this.loading = true;

        let {
          checked,
          note,
          group_prescription_care: {
            prescription_care: { care_name },
            prescription_care_time: { id },
          },
          date,
          description,
          initial_description,
          final_description,
        } = this;

        if (care_name == "PRESSÃO ARTERIAL") {
          description = `${description}X${final_description}`;
        }

        let params = {
          checked,
          note,
          id,
          date,
          description,
          initial_description,
          final_description,
        };

        const response = await api.post(
          "/rest-home/check/separate-care",
          params
        );

        const { error, errors, message, created_id } = response.data;

        if (!error) {
          toast(message, "success");
          if (permission("read", "change_of_position_with_photo")) {
            await this.uploadPhoto(created_id);
          }
          this.$emit("success");
          this.$emit("checked");
          this.errors = [];
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async uploadPhoto(id) {
      try {
        if (!id) {
          return;
        }

        let {
          checked,
          group_prescription_care: {
            prescription_care: { care_category },
          },
          photo,
        } = this;

        if (!checked) {
          if (care_category != "Mudança de Decúbito e Prevenção") {
            return;
          }
        }

        const formData = new FormData();
        formData.append("id", id);
        formData.append("photo", photo);

        await api.post("/rest-home/check/separate-care/upload-photo", formData);

        this.photo = null;
      } catch (error) {
        this.photo = null;
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.separate-care-care-field-required p {
  margin: 0;
  padding: 5px;
  border-radius: 5px;
  background-color: #f8f4d1;
  color: #978b1e;
}
</style>